import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useSetIdentityEmailMutation } from '../../graphql/react-operations';
import { EditableEmail } from './EditableEmail';
import { type RefetchQueriesInclude } from '@apollo/client';

export const IdentityEditableEmail = ({
  id,
  children,
  refetchQueries,
}: {
  children: string | null | undefined;
  id: string;
  refetchQueries: RefetchQueriesInclude;
}) => {
  const companyId = useCompanyId();
  // eslint-disable-next-line sut/loading-mutation
  const [doSetEmail] = useSetIdentityEmailMutation();

  const handleOnChange = async (email: string | null) => {
    await doSetEmail({ variables: { companyId, input: { id, email: email ?? '' } } });
  };

  return (
    <EditableEmail onChange={handleOnChange} refetchQueries={refetchQueries}>
      {children}
    </EditableEmail>
  );
};
